@if (!readonly) {
  <p-inputSwitch
    [ngModel]="internalValue"
    (ngModelChange)="updateChanges($event)">
  </p-inputSwitch>
}

@if (readonly) {
  <span>{{ (internalValue ? 'YES' : 'NO') | translate }}</span>
}